import { takeLatest, put, call } from 'redux-saga/effects';
import {
    SCORECARD_ID,
    getScorecardDetails,
    getScorecardDetailsFailure,
    REQUEST_BODY,
    editScorecardSuccess,
    editScorecardError,
    CREATE_REQUEST_BODY,
    createScorecardSuccess,
    createScorecardFailure,
    SEARCH_CORPORATE_PARAMETER_SCORECARD,
    searchCorporateResultsScorecardFailure,
    searchCorporateResultsScorecardSuccess
} from './action';
import { HTTP_HEADERS } from '../../../constants';
import request from '../../../components/Utils/httpHelper';
import { SCORE_DEFINATION, CORE_API } from '../../../config';

export function* ScorecardDetails(action) {
    let requestUrl = `${SCORE_DEFINATION}/scorecard/${action.data}`;
    try {
        const scorecard = yield call(request, requestUrl, { data: '', method:'GET', headers: HTTP_HEADERS });
        yield put(getScorecardDetails(scorecard.data))
    }
    catch (err) {
        yield put(getScorecardDetailsFailure(err))
    }
}
export function* fetchScorecardDetails() {
    yield takeLatest(SCORECARD_ID, ScorecardDetails);
}

export function* updateScorecard(action) {
    let requestUrl = `${SCORE_DEFINATION}/scorecard/`;
    if (action.data.id) {
        try {
            const editscorecard = yield call(request, requestUrl, { data: action.data, method:'PUT', headers: HTTP_HEADERS });
            yield put(editScorecardSuccess(editscorecard));
        } catch (err) {
            yield put(editScorecardError(err));
        }
    } else {
        try {
            const createscorecard = yield call(request, requestUrl, { data: action.data, method:'POST', headers: HTTP_HEADERS });
            yield put(createScorecardSuccess(createscorecard));
        } catch (err) {
            yield put(createScorecardFailure(err));
        }
    }
}
export function* editScorecard() {
    yield takeLatest(REQUEST_BODY, updateScorecard);
}

export function* addScorecard(action) {
    let requestUrl = `${SCORE_DEFINATION}/scorecard/`;
    try {
        const createscorecard = yield call(request, requestUrl, { data: action.data, method:'POST', headers: HTTP_HEADERS });
        yield put(createScorecardSuccess(createscorecard));
    } catch (err) {
        yield put(createScorecardFailure(err));
    }
}
export function* createScorecard() {
    yield takeLatest(CREATE_REQUEST_BODY, addScorecard);
}

export function* corporateSearchforScorecard(action) {
    let requestURL = `${CORE_API}/corporate/autocomplete/name/${action.search}`;
    try {
        const searchResult = yield call(request, requestURL, {
            method: 'GET',
            data: '',
            headers: HTTP_HEADERS
        });
        
        yield put(searchCorporateResultsScorecardSuccess(searchResult.data));
    } catch (err) {
        yield put(searchCorporateResultsScorecardFailure(err))
    }
}
export function* getCorporateSearchforScoreCard() {
    yield takeLatest(SEARCH_CORPORATE_PARAMETER_SCORECARD, corporateSearchforScorecard);
}
